// extracted by mini-css-extract-plugin
module.exports = {"no-margin":"comfort-and-safety_no-margin__gf_hT","phAnimation":"comfort-and-safety_phAnimation__891NS"};